import React, { useState } from 'react';
import {
  List, ListItemButton, ListItemIcon, ListItemText, Collapse,
  Typography, Box, Badge
} from '@mui/material';
import {
  Settings, Mic, Search, ListAlt,
  ExpandLess, ExpandMore, AccessTime, ViewList, Schedule,
  AdminPanelSettings
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../AuthContext';

function NavigationDrawer({ onNavigate }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [openManagement, setOpenManagement] = useState(
    location.pathname.startsWith('/recorded')
  );
  const { isAdmin } = useAuth();

  // web-radio 側欄列表式樣：貼齊邊緣、每列 1px 底線
  const itemSx = {
    px: 3,
    py: 1.5,
    borderBottom: 1,
    borderColor: 'divider',
  };

  const itemTextProps = { fontSize: 13 };

  // 區塊標籤：小字、字距拉開、muted（web-radio 標籤式樣）
  const sectionLabelSx = {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '1px',
    color: 'text.disabled',
  };

  const sectionSx = {
    px: 3,
    pt: 2.5,
    pb: 1,
    borderBottom: 1,
    borderColor: 'divider',
  };

  const isActive = (path) => location.pathname === `/${path}`;

  const handleListItemClick = (path) => {
    navigate(`/${path}`);
    if (onNavigate) onNavigate(); // 手機模式下自動關閉 Drawer
  };

  const toggleManagement = () => {
    setOpenManagement(!openManagement);
  };

  return (
    <List disablePadding>
      {/* 管理員專用功能區塊 */}
      {isAdmin && (
        <>
          <Box sx={sectionSx}>
            <Typography sx={sectionLabelSx}>管理員功能</Typography>
          </Box>

          <ListItemButton sx={itemSx} selected={isActive('auto')} onClick={() => handleListItemClick('auto')}>
            <ListItemIcon>
              <Badge color="error" variant="dot">
                <AdminPanelSettings fontSize="small" />
              </Badge>
            </ListItemIcon>
            <ListItemText primary="自動錄製設定" primaryTypographyProps={itemTextProps} />
          </ListItemButton>
        </>
      )}

      {/* 一般功能區塊 */}
      <Box sx={sectionSx}>
        <Typography sx={sectionLabelSx}>錄製功能</Typography>
      </Box>

      <ListItemButton sx={itemSx} selected={isActive('table')} onClick={() => handleListItemClick('table')}>
        <ListItemIcon><Mic fontSize="small" /></ListItemIcon>
        <ListItemText primary="手動選擇錄製" primaryTypographyProps={itemTextProps} />
      </ListItemButton>

      <ListItemButton sx={itemSx} selected={isActive('pending')} onClick={() => handleListItemClick('pending')}>
        <ListItemIcon><Schedule fontSize="small" /></ListItemIcon>
        <ListItemText primary="待錄製列表" primaryTypographyProps={itemTextProps} />
      </ListItemButton>

      <ListItemButton sx={itemSx} selected={isActive('search')} onClick={() => handleListItemClick('search')}>
        <ListItemIcon><Search fontSize="small" /></ListItemIcon>
        <ListItemText primary="節目搜索與錄製" primaryTypographyProps={itemTextProps} />
      </ListItemButton>

      <Box sx={sectionSx}>
        <Typography sx={sectionLabelSx}>錄製管理</Typography>
      </Box>

      <ListItemButton sx={itemSx} selected={location.pathname.startsWith('/recorded')} onClick={toggleManagement}>
        <ListItemIcon><ViewList fontSize="small" /></ListItemIcon>
        <ListItemText primary="已錄製內容" primaryTypographyProps={itemTextProps} />
        {openManagement ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
      </ListItemButton>

      <Collapse in={openManagement} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton sx={{ ...itemSx, pl: 6 }} selected={isActive('recorded')} onClick={() => handleListItemClick('recorded')}>
            <ListItemIcon>
              <AccessTime fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="依日期查看" primaryTypographyProps={itemTextProps} />
          </ListItemButton>

          <ListItemButton sx={{ ...itemSx, pl: 6 }} selected={location.pathname.startsWith('/recorded/')} onClick={() => handleListItemClick('recorded/stations')}>
            <ListItemIcon>
              <ListAlt fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="依節目查看" primaryTypographyProps={itemTextProps} />
          </ListItemButton>
        </List>
      </Collapse>

      {/* 自動錄製規則查看 (所有用戶都可訪問) */}
      <ListItemButton sx={itemSx} selected={isActive('auto-view')} onClick={() => handleListItemClick('auto-view')}>
        <ListItemIcon><Settings fontSize="small" /></ListItemIcon>
        <ListItemText primary="自動錄製規則" primaryTypographyProps={itemTextProps} />
      </ListItemButton>
    </List>
  );
}

export default NavigationDrawer;
